import { UpdateInternalUserRequest } from '../../../../web-api-client';
import { InternalUser } from '../../models';

export const mapInternalUserToUpdateRequest = (
  user: InternalUser
): UpdateInternalUserRequest => {
  return new UpdateInternalUserRequest({
    id: user.id,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    isActive: user.isActive,
    termsAndPrivacyAccepted: user.termsAndPrivacyAccepted ?? false,
  });
};
